/*
  Keeps the theme's header cart bubble in sync with Rebuy's cart, with no page reload.

  Two separate reasons the native bubble never updated on this theme:
    1. Rebuy's own updateCartCount() writes into settings.selectors.item_count, which is set to
       ".cart-count" - a selector that matches nothing here. The theme's element is
       ".cart-icon-bubble__count".
    2. snippets/cart-icon-bubble.liquid only renders that element when `cart != empty`, so on an
       empty cart there is no node to update at all and the first add had nothing to write to.

  So this listens to Rebuy's documented cart event, reads Rebuy.Cart.itemCount() as the source of
  truth, and creates the bubble when Liquid omitted it. Rebuy's own selector is left alone - it
  simply no-ops - so there is no dashboard change to keep in step with this file.
*/
(function () {
  'use strict';

  var COUNT_CLASS = 'cart-icon-bubble__count';
  var BUTTON_SELECTOR = '.cart-icon-bubble__button';

  // Rebuy's authoritative item count, or null while the SDK is still coming up. Never guess from
  // the DOM: the Liquid-rendered count is stale on a cached page, which is the bug being fixed.
  function rebuyItemCount() {
    try {
      if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.itemCount === 'function') {
        var count = Rebuy.Cart.itemCount();
        return typeof count === 'number' && isFinite(count) ? count : null;
      }
    } catch (error) {
      return null;
    }
    return null;
  }

  // The theme's locale strings are only reachable from Liquid, so rebuy-extensions.liquid passes
  // them through window.rebuyCartBubbleStrings. Falls back to English rather than rendering an
  // empty screen-reader label if that block is ever dropped.
  function labelFor(count) {
    var strings = window.rebuyCartBubbleStrings || {};
    return count === 1 ? strings.one || 'item' : strings.other || 'items';
  }

  // Builds the element that cart-icon-bubble.liquid skips on an empty cart, matching its markup
  // exactly so the theme's existing CSS applies untouched.
  function ensureBubble(button) {
    var bubble = button.querySelector('.' + COUNT_CLASS);
    if (bubble) return bubble;

    bubble = document.createElement('div');
    bubble.className = COUNT_CLASS;

    var numeral = document.createElement('span');
    numeral.setAttribute('aria-hidden', 'true');

    var srOnly = document.createElement('span');
    srOnly.className = 'sr-only';

    bubble.appendChild(numeral);
    bubble.appendChild(srOnly);
    button.appendChild(bubble);

    return bubble;
  }

  // Mirrors the Liquid it stands in for: the numeral is suppressed at 100+, the screen-reader
  // label always carries the number, and the bubble disappears entirely on an empty cart.
  // Visibility is set inline rather than via [hidden] because the theme's stylesheet gives
  // .cart-icon-bubble__count a display value, which would otherwise win.
  function render(count) {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);

    for (var i = 0; i < buttons.length; i++) {
      var bubble = ensureBubble(buttons[i]);
      var numeral = bubble.querySelector('[aria-hidden="true"]');
      var srOnly = bubble.querySelector('.sr-only');

      bubble.style.display = count < 1 ? 'none' : '';
      if (numeral) numeral.textContent = count < 100 ? String(count) : '';
      if (srOnly) srOnly.textContent = count + ' ' + labelFor(count);
    }
  }

  function sync() {
    var count = rebuyItemCount();
    if (count !== null) render(count);
  }

  // rebuy:cart.change covers every mutation Rebuy knows about - Smart Cart quantity steppers and
  // removes, widget add-to-carts, and the bundle builder's multi-add. The theme's own PDP form is
  // intercepted by Rebuy too, so it lands here as well.
  document.addEventListener('rebuy:cart.change', sync);
  document.addEventListener('rebuy:smartcart.ready', sync);

  // First paint: the SDK loads async, so the initial count may not be readable yet. Poll briefly
  // rather than waiting on a lifecycle event alone, which can fire before this file is parsed.
  (function pollForFirstSync() {
    var attempts = 0;

    var timer = setInterval(function () {
      attempts++;
      if (rebuyItemCount() !== null) {
        sync();
        clearInterval(timer);
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 100);
  })();
})();
